import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ForgotPasswordModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ForgotPasswordModalContainer" */
      './ForgotPasswordModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
